import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-lupa-data.png';

// Definindo o tipo das props
interface NavbarProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

// Componente Navbar com tipagem correta
const Navbar: React.FC<NavbarProps> = ({ darkMode, toggleDarkMode }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [tecnologiasDropdown, setTecnologiasDropdown] = useState(false);
  const [solucoesDropdown, setSolucoesDropdown] = useState(false);
  const tecnologiasRef = useRef<HTMLDivElement>(null);
  const solucoesRef = useRef<HTMLDivElement>(null);

  // Fechar dropdowns quando clicar fora deles
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (tecnologiasRef.current && !tecnologiasRef.current.contains(event.target as Node)) {
        setTecnologiasDropdown(false);
      }
      if (solucoesRef.current && !solucoesRef.current.contains(event.target as Node)) {
        setSolucoesDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Função para alternar o menu mobile
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  // Função para alternar o dropdown de tecnologias
  const toggleTecnologias = (e: React.MouseEvent) => {
    e.preventDefault();
    setTecnologiasDropdown(!tecnologiasDropdown);
    setSolucoesDropdown(false);
  };

  // Função para alternar o dropdown de soluções
  const toggleSolucoes = (e: React.MouseEvent) => {
    e.preventDefault();
    setSolucoesDropdown(!solucoesDropdown);
    setTecnologiasDropdown(false);
  };

  // Função para navegação mobile - força reload da página
  const handleMobileNavigation = (path: string) => {
    window.location.href = path;
  };

  return (
    <header className="bg-white dark:bg-gray-900 shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img src={logo} alt="Lupa Data" className="h-10" />
            </Link>
          </div>

          {/* Menu Desktop */}
          <nav className="hidden md:flex space-x-8">
            <div ref={tecnologiasRef} className="relative">
              <button
                onClick={toggleTecnologias}
                className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-sm font-medium flex items-center"
              >
                Tecnologias
                <svg
                  className={`ml-1 h-4 w-4 transition-transform ${tecnologiasDropdown ? 'rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {tecnologiasDropdown && (
                <div className="absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-50">
                  <div className="py-1">
                    <Link
                      to="/tecnologias/data-lakehouse"
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                      onClick={() => setTecnologiasDropdown(false)}
                    >
                      Data Lakehouse
                    </Link>
                    <Link
                      to="/tecnologias/ia"
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                      onClick={() => setTecnologiasDropdown(false)}
                    >
                      Inteligência Artificial
                    </Link>
                    <Link
                      to="/tecnologias/machine-learning"
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                      onClick={() => setTecnologiasDropdown(false)}
                    >
                      Machine Learning
                    </Link>
                    <Link
                      to="/tecnologias/big-data"
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                      onClick={() => setTecnologiasDropdown(false)}
                    >
                      Big Data
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <div ref={solucoesRef} className="relative">
              <button
                onClick={toggleSolucoes}
                className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-sm font-medium flex items-center"
              >
                Soluções
                <svg
                  className={`ml-1 h-4 w-4 transition-transform ${solucoesDropdown ? 'rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {solucoesDropdown && (
                <div className="absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-white dark:bg-gray-800 ring-1 ring-black ring-opacity-5 z-50">
                  <div className="py-1">
                    <Link
                      to="/solucoes/lupa-paranoa"
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                      onClick={() => setSolucoesDropdown(false)}
                    >
                      Lupa Paranoá
                    </Link>
                    <Link
                      to="/solucoes/lupa-cast"
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                      onClick={() => setSolucoesDropdown(false)}
                    >
                      Lupa Cast
                    </Link>
                    <Link
                      to="/solucoes/lia"
                      className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
                      onClick={() => setSolucoesDropdown(false)}
                    >
                      LIA
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/servicos"
              className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-sm font-medium"
            >
              Serviços
            </Link>
            <Link
              to="/parceiros"
              className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-sm font-medium"
            >
              Parceiros
            </Link>
            <Link
              to="/sobre-nos"
              className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-sm font-medium"
            >
              Sobre Nós
            </Link>
          </nav>

          {/* Botões da direita */}
          <div className="hidden md:flex items-center space-x-4">
            {/* Botão de modo escuro/claro */}
            <button
              onClick={toggleDarkMode}
              className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange p-2 rounded-full"
              aria-label={darkMode ? "Ativar modo claro" : "Ativar modo escuro"}
            >
              {darkMode ? (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
              ) : (
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                  />
                </svg>
              )}
            </button>

            {/* Botão de contato */}
            <Link
              to="/contato"
              className="bg-lupa-orange hover:bg-lupa-orange/90 text-white px-4 py-2 rounded-md text-sm font-medium"
            >
              Fale Conosco
            </Link>
          </div>

          {/* Botão do menu mobile */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange p-2"
              aria-label="Menu principal"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {menuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Menu Mobile */}
      {menuOpen && (
        <div className="md:hidden bg-white dark:bg-gray-900 shadow-md">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <div>
              <button
                onClick={toggleTecnologias}
                className="w-full text-left text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-base font-medium flex items-center justify-between"
              >
                Tecnologias
                <svg
                  className={`ml-1 h-4 w-4 transition-transform ${tecnologiasDropdown ? 'rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {tecnologiasDropdown && (
                <div className="pl-4 py-2 space-y-2">
                  <div
                    className="block px-3 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    onClick={() => handleMobileNavigation('/tecnologias/data-lakehouse')}
                  >
                    Data Lakehouse
                  </div>
                  <div
                    className="block px-3 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    onClick={() => handleMobileNavigation('/tecnologias/ia')}
                  >
                    Inteligência Artificial
                  </div>
                  <div
                    className="block px-3 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    onClick={() => handleMobileNavigation('/tecnologias/machine-learning')}
                  >
                    Machine Learning
                  </div>
                  <div
                    className="block px-3 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    onClick={() => handleMobileNavigation('/tecnologias/big-data')}
                  >
                    Big Data
                  </div>
                </div>
              )}
            </div>

            <div>
              <button
                onClick={toggleSolucoes}
                className="w-full text-left text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-base font-medium flex items-center justify-between"
              >
                Soluções
                <svg
                  className={`ml-1 h-4 w-4 transition-transform ${solucoesDropdown ? 'rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {solucoesDropdown && (
                <div className="pl-4 py-2 space-y-2">
                  <div
                    className="block px-3 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    onClick={() => handleMobileNavigation('/solucoes/lupa-paranoa')}
                  >
                    Lupa Paranoá
                  </div>
                  <div
                    className="block px-3 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    onClick={() => handleMobileNavigation('/solucoes/lupa-cast')}
                  >
                    Lupa Cast
                  </div>
                  <div
                    className="block px-3 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-md cursor-pointer"
                    onClick={() => handleMobileNavigation('/solucoes/lia')}
                  >
                    LIA
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/servicos"
              className="block text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-base font-medium"
              onClick={() => setMenuOpen(false)}
            >
              Serviços
            </Link>
            <Link
              to="/parceiros"
              className="block text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-base font-medium"
              onClick={() => setMenuOpen(false)}
            >
              Parceiros
            </Link>
            <Link
              to="/sobre-nos"
              className="block text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange px-3 py-2 rounded-md text-base font-medium"
              onClick={() => setMenuOpen(false)}
            >
              Sobre Nós
            </Link>

            <div className="flex items-center justify-between pt-4 border-t border-gray-200 dark:border-gray-700">
              <button
                onClick={toggleDarkMode}
                className="text-gray-700 dark:text-gray-300 hover:text-lupa-orange dark:hover:text-lupa-orange p-2 rounded-full"
                aria-label={darkMode ? "Ativar modo claro" : "Ativar modo escuro"}
              >
                {darkMode ? (
                  <div className="flex items-center">
                    <svg className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                    <span>Modo Claro</span>
                  </div>
                ) : (
                  <div className="flex items-center">
                    <svg className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
                      />
                    </svg>
                    <span>Modo Escuro</span>
                  </div>
                )}
              </button>

              <Link
                to="/contato"
                className="bg-lupa-orange hover:bg-lupa-orange/90 text-white px-4 py-2 rounded-md text-sm font-medium"
                onClick={() => setMenuOpen(false)}
              >
                Fale Conosco
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;

